import { z } from 'zod';
import { profileSchema, psnAccountSchema } from './user.js';
/**
 * Drei Zustaende. Gast ist First-Class – es gibt keinen blockierenden Login.
 * Account und PSN-Account sind getrennte Konzepte.
 */
export const authStateSchema = z.discriminatedUnion('kind', [
    z.object({ kind: z.literal('guest') }),
    z.object({ kind: z.literal('account'), profile: profileSchema }),
    z.object({
        kind: z.literal('psn_linked'),
        profile: profileSchema,
        psnAccount: psnAccountSchema,
    }),
]);
export function isSignedIn(state) {
    return state.kind !== 'guest';
}
export function hasVerifiedPsn(state) {
    return state.kind === 'psn_linked' && state.psnAccount.verificationState === 'verified';
}
export function capabilitiesFor(state) {
    return {
        localRuns: true,
        cloudSync: isSignedIn(state),
        trophySync: hasVerifiedPsn(state),
        publicProfile: hasVerifiedPsn(state),
    };
}
//# sourceMappingURL=auth.js.map